/**
 * ScreenContainer - Mobile
 * 
 * Base wrapper for all mobile screens.
 * Handles safe areas for portrait AND landscape.
 */

import React from 'react';
import { View, StyleSheet, ViewStyle } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { color } from '../../../shared/tokens/mobile';

interface ScreenContainerProps {
  children: React.ReactNode;
  style?: ViewStyle;
}

export function ScreenContainer({ children, style }: ScreenContainerProps) {
  return (
    <SafeAreaView 
      style={styles.safe} 
      edges={['top', 'left', 'right']}
    >
      <View style={[styles.container, style]}>
        {children}
      </View>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  safe: {
    flex: 1,
    backgroundColor: color.background,
  },
  container: {
    flex: 1,
  },
});
